import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CreateReviewRequest } from 'pages/Ai/types';

import Button from 'components/common/Button/Button';
import ModalDialog from 'components/common/ModalDialog/ModalDialog';
import requestAPI from 'utils/apiHandler';
import { uploadFile } from 'utils/fileHelper';

import StepOne from './CreateForm/StepOne';
import StepTwo from './CreateForm/StepTwo';

const CreateReview = () => {
  const [open, setOpen] = useState(false);
  const [model, setModel] = useState<CreateReviewRequest>();
  const [files, setFiles] = useState([]);
  const [step, setStep] = useState(1);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const history = useHistory();
  const handleChage = (key, value) => {
    setModel(val => {
      return {
        ...val,
        [key]: value,
      };
    });
  };

  const stepLogic = {
    1: () => {
      setLoading(true);
      setError('');
      if (!model) {
        setError(t('aireview:required_fields_error'));
        setLoading(false);
        return;
      }
      const { documentId, classId, subjectId } = model;

      if (!documentId || !classId || !subjectId) {
        setError(t('aireview:required_fields_error'));
        setLoading(false);
        return;
      }
      setStep(2);

      setLoading(false);
    },
    2: () => {
      setError('');
      if (files.length === 0) {
        setError(t('aireview:add_documents_error'));
        return;
      }
      const uploadedFiles = [];
      setLoading(true);
      files.forEach(obj => {
        uploadedFiles.push(uploadFile(obj));
      });

      Promise.all(uploadedFiles)
        .then(res => res.map(obj => obj.id))
        .then(res =>
          requestAPI({
            url: '/review',
            method: 'POST',
            data: { ...model, fileIds: res },
          }).then(res => {
            if (res.message) {
              setError(res.message);
              setLoading(false);
              return;
            }
            history.push(`/ai/review/${res.insertedId}`);
          })
        )
        .catch(() => {
          setError(t('aireview:something_went_wrong'));
          setLoading(false);
        });
    },
  };
  const handleNextClick = () => {
    stepLogic[step]();
  };
  return (
    <span>
      <Button
        style={{ marginLeft: 'auto' }}
        key="btn"
        label={t('aireview:New_document_review')}
        onClick={() => setOpen(true)}
      />
      <ModalDialog
        key="modal"
        className="modal-sm"
        open={open}
        onClose={() => setOpen(false)}
        title={t('aireview:new_evaluation')}
        actions={[
          <Button
            isLoading={loading}
            key="next_btn"
            label={t('aireview:Next')}
            className="w-100"
            onClick={handleNextClick}
          />,
        ]}
      >
        <div>
          {step === 1 && <StepOne onChange={handleChage} />}
          {step === 2 && <StepTwo onChange={(key, val) => setFiles(val)} />}

          <div className="topGreyBorder m-1" />
          <div className="error m-1">{error}</div>
        </div>
      </ModalDialog>
    </span>
  );
};

export default CreateReview;
